export default "__VITE_ASSET__267a2cea__"